import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

const crudActions = restCrudActions({
    endpointBasePath: 'instance',
    pluginName: 'SERVER_INSTANCE',
    entityName: 'SERVER_INSTANCE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch Server Instance action creators
export const fetchServerInstanceInit = () => { return crudActions.fetchInit(); }
export const fetchServerInstanceStart = (fetchServerInstanceCount, listServerInstanceCount) => {
    return crudActions.fetchSuccess(fetchServerInstanceCount, listServerInstanceCount);
};
export const fetchServerInstanceSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchServerInstanceFail = () => { return crudActions.fetchFail(); }
export const fetchServerInstancesCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchServerInstanceStart());
        try {
            let countRes = await rest.post("instance/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchServerInstanceSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchServerInstanceFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch server instances."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchServerInstanceFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch server instances."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchServerInstances = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchServerInstanceStart());
        try {
            let listRes = await rest.post("instance/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchServerInstanceSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchServerInstanceFail());
            return []

        } catch (error) {
            dispatch(fetchServerInstanceFail());
            return []

        }
    }
}
